import { strings } from 'APP_ROOT/localization';

export default class MapboxToggleFullscreenControl {

    mapboxControlShouldFullscreen;
    mapboxControlCallback;

    constructor(fullscreenByDefault, callbackForButtonEventListener) {
        this.mapboxControlShouldFullscreen = fullscreenByDefault;
        this.mapboxControlCallback = callbackForButtonEventListener;
    }

    buttonEventListener = () => {

        this.mapboxControlShouldFullscreen = !this.mapboxControlShouldFullscreen; // toggle
        this.mapboxControlCallback(this.mapboxControlShouldFullscreen);
    }

    onAdd(map) {
        this.map = map;
        this.container = this.container();
        return this.container;
    }

    onRemove() {
        this.container.parentNode.removeChild(this.container);
        this.mapboxComponentClassCallback = undefined;
        this.map = undefined;
    }

    button() {

        var imageElement = document.createElement('img');
        imageElement.src = '/images/map-btn-fullscreen.png';
        imageElement.style = "width: 30px; padding: 3px;"; /* using padding to shrink the icon down while keeping overall width 30px */

        var buttonElement = document.createElement('button');
        buttonElement.id = 'toggleFullscreenBtn';
        buttonElement.title = strings.map_controls_label_toggle_fullscreen;
        buttonElement.appendChild(imageElement);

        buttonElement.addEventListener('click', this.buttonEventListener);

        var buttonWrapper = document.createElement('div');
        buttonWrapper.appendChild(buttonElement);

        return buttonWrapper;
    }

    container() {
        var buttonWrapperContainer = document.createElement('div');
        buttonWrapperContainer.className = 'mapboxgl-ctrl mapboxgl-ctrl-group';
        buttonWrapperContainer.appendChild(this.button());
        return buttonWrapperContainer;
    }
}